<template>
    <div class="dizhi">
        <van-nav-bar :title="title" left-text="" @click-left="onClickLeft" left-arrow :fixed="true">
        </van-nav-bar>
        <van-address-list
                v-model="addressId"
                :list="list"
                @add="onAdd"
                @edit="onEdit"
                @select="onClickSelect"
        />
    </div>
</template>

<script>
    import {getCookie, getDeptId, getDeptName} from "../../utils/auth";

    export default {
        data() {
            return {
                title: '地址',
                deptId: '',
                token: '',
                addressId: '',
                phone: '',
                list: [],
            };
        },
        async created() {
            document.title = getDeptName()
            this.token = getCookie('spmToken')
            this.deptId = getDeptId()
            this.getAddressList()
        },
        methods: {
            onAdd() {
                this.$router.push('/addAddress/' + this.deptId)
            },

            onEdit(item) {
                this.$router.push('/editAddress/' + this.deptId + '/' + item.id)
            },
            async getAddressList() {
                let data = {
                    token: this.token
                }
                let res = await this.$get("/spm/getSpmAddressList", data)
                this.list = res.list
                this.addressId = res.adsId
            },

            onClickSelect(item) {
                this.$route.params.adsId = item.id;
                this.$router.back();
            },
            onClickLeft() {
                if (window.history.length > 1) {
                    this.$router.back();
                } else {
                    this.$router.push('/home/' + this.deptId)
                }
            }
        },
    };
</script>

<style lang="scss" scoped>

    .dizhi {
        padding-top: 50px;
        padding-bottom: 50px;
        overflow: scroll;
    }

    ::v-deep .van-nav-bar__title {
        max-width: 60%;
        margin: 0 auto;
        color: #323233;
        font-weight: 500;
        font-size: 15px;
    }


</style>
